import {
  DRAWER_TITLE_ID,
  DrawerTitle,
  Subhead,
  useRebrand,
} from "@growtherapy/sprout-ui";
import { useTranslate } from "@growtherapy/i18n";

export function Header() {
  const t = useTranslate();
  const isRebrand = useRebrand();
  const headerText = t("telehealth-core:moodCheckin.howAreYouFeelingToday");

  if (isRebrand) {
    return (
      <Subhead.Default as="h2" id={DRAWER_TITLE_ID}>
        {headerText}
      </Subhead.Default>
    );
  }

  return <DrawerTitle>{headerText}</DrawerTitle>;
}
